import { combineReducers } from "redux";
import { firebaseReducer } from "react-redux-firebase";
import { firestoreReducer } from "redux-firestore";
// import taskReducer from "./taskReducer";
import authReducer from "./authReducer";
import userReducer from "./userReducer";
import organizationReducer from "./organizationReducer";
import ciqualCategoriesReducer from "./ciqualCategoriesReducer";
import analysisReducer from "./analysisReducer";
// import undoableAnalysisReducer from "./analysisReducer";
import optimizationReducer from "./optimizationReducer";
import flow from "./flowReducer";
import comReducer from "./comReducer";
import { reducer as formReducer } from "redux-form";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web

// import { persistStore, persistReducer } from "redux-persist";

// const persistConfig = {
//   key: "root",
//   storage,
//   blacklist: ["ciqualCategories", "analysis", "com"],
// };

// // blacklist nested to analysis
// const analysisPersistConfig = {
//   key: "analysis",
//   storage: storage,
//   blacklist: ["past", "future"],
// };
// const comPersistConfig = {
//   key: "com",
//   storage: storage,
//   blacklist: ["past", "future"],
// };

// const persistedReducer = persistReducer(persistConfig, rootReducer)

// const rootReducer = combineReducers({

//   other: otherReducer,
// })

// const rootReducer = combineReducers({
//   firebase: firebaseReducer,
//   firestore: firestoreReducer,
//   flow: flow,
//   ciqualCategories: ciqualCategoriesReducer,
//   analysis: analysisReducer,
//   optimization: optimizationReducer,
//   com: comReducer,
//   auth: authReducer,
//   user: userReducer,
//   organization: organizationReducer,
//   form: formReducer,
// });

const appReducer = combineReducers({
  firebase: firebaseReducer,
  firestore: firestoreReducer,
  flow: flow,
  ciqualCategories: ciqualCategoriesReducer,
  analysis: analysisReducer,
  optimization: optimizationReducer,
  com: comReducer,
  auth: authReducer,
  user: userReducer,
  organization: organizationReducer,
  form: formReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "LOGOUT" || action.type === "CLEAR_STORE") {
    storage.removeItem("persist:root");
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default rootReducer;
